import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import {
    AbstractBaseAddress,
    AddressService,
    AddressType,
    CompanyAddressWithContact,
    ICompanyAddressWithContact,
    ShippingAddress,
} from '@lib/address';

@Component({
    selector: 'demand-shipping-display',
    templateUrl: './demand-shipping-display.component.html',
    styleUrls: ['./demand-shipping-display.component.scss'],
    standalone: false
})
export class DemandShippingDisplayComponent {
    private readonly addressService = inject(AddressService);

    @Input() companyAddress!: ICompanyAddressWithContact;
    @Input() readonly = true;
    /** Site-aware delivery-address union for this document (EPROC-10909). When set, it is offered instead of all user addresses. */
    @Input() availableShippingAddresses?: ShippingAddress[];

    @Output() private readonly addressChanged: EventEmitter<ShippingAddress> = new EventEmitter<ShippingAddress>();

    public openAddressSelection(): void {
        const currentAddress: ShippingAddress = new ShippingAddress(
            CompanyAddressWithContact.fromInterface(this.companyAddress)
        );
        this.addressService
            .selectAddress(AddressType.SHIPPING, currentAddress, null, this.availableShippingAddresses)
            .subscribe((newAddress?: AbstractBaseAddress) => {
                if (newAddress && newAddress instanceof ShippingAddress) {
                    this.addressChanged.emit(newAddress);
                }
            });
    }
}
